import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-28 bg-white text-gray-800">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">Privacy Policy</h1>

      <p className="mb-4">
        At <strong className="text-gray-800">Velonix Solution</strong>, we are
        strongly committed to protecting users' privacy, and this Privacy Policy
        governs our data collection, processing, and usage policies for our
        websites, including{" "}
        <a
          href="mailto:service@velonixsolution.com"
          className="text-blue-600 underline"
        >
          service@velonixsolution.com
        </a>
        . We periodically update this policy. If you do not agree with the
        practices in this Privacy Policy, you should not use the website. If you
        have any questions about this Privacy Policy or how we manage the
        information that you provide us, please email us at{" "}
        <a
          href="mailto:service@velonixsolution.com"
          className="text-blue-600 underline"
        >
          service@velonixsolution.com
        </a>
        .
      </p>

      <p className="mb-4">
        <strong className="text-gray-800">Velonix Solution</strong> collects
        personal information that you submit to us, including contact
        information or information about you that is available on the internet
        from sources such as LinkedIn, Twitter, Facebook, or Google, or publicly
        available information that we acquire from service providers.
      </p>

      <p className="mb-4">
        <strong className="text-gray-800">Velonix Solution</strong> utilizes
        various JavaScript-based tracking software (notably Google Analytics,
        AdRoll, and Pardot) to collect data from every visitor to the website.
        If you wish to opt out of any type of visitor tracking, we recommend
        disabling JavaScript in your browser options.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        Use of Information
      </h2>
      <p className="mb-4">
        We will only use the information you provide to us to communicate with
        you about our products and services or for the purpose for which such
        information was provided. Users may opt out of receiving mailings from
        us by clicking the link in the footer of email communications. We
        reserve the right to access and disclose personal information to comply
        with applicable laws and lawful government requests, to operate our
        systems properly, or to protect either ourselves or our users.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        Data Confidentiality
      </h2>
      <p className="mb-4">
        <strong className="text-gray-800">Velonix Solution</strong> does not
        share your personal information with third parties. We may use
        collective identified customer data and statistics for internal analysis
        and external marketing purposes.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        Security
      </h2>
      <p className="mb-4">
        The website has industry standard security measures in place to protect
        the loss, misuse, and alteration of the information under our control.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
